import './GanttChartLine.css';
export var wrapperCSS = '_yatlwj0-2-0-1';